export default {
	signInButtonLabel: 'Sign in',
	signUpButtonLabel: 'Sign up now',
};
